export enum PaymentMethod {
    CASH = "cash",
    PIN = "pin",
    PIN_CASH = "pin_cash",
    INVOICE = "account",
    ONLINE = "online",
    SPLIT_PAYMENT = "split_payment",
}
